import { useEffect, useMemo, useState } from "react";

import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";

import MKTypography from "components/MKTypography";
import api from "services/api";
import { useTranslation } from "react-i18next";
import { openWrtSections } from "pages/Clients/clientDownloadData";
import SignedDownloadButton from "./SignedDownloadButton";

function OpenWrtDesc() {
  const { t } = useTranslation();
  const [software, setSoftware] = useState(null);
  const downloads = software?.items || [];

  useEffect(() => {
    api
      .get("/software/openwrt/")
      .then((res) => {
        setSoftware(res?.data || null);
      })
      .catch(() => {
        setSoftware(null);
      });
  }, []);

  const downloadsByTypeAndArch = useMemo(() => {
    const map = new Map();
    downloads.forEach((download) => {
      map.set(`${download.package_type}:${download.arch}`, download);
    });
    return map;
  }, [downloads]);

  return (
    <Card
      sx={{
        p: { xs: 2, md: 3 },
        mx: { xs: 2, lg: 3 },
        mt: 2,
        mb: 2,
        boxShadow: ({ boxShadows: { lg } }) => lg,
      }}
    >
      <MKTypography variant="h5" fontWeight="bold" mb={1}>
        {t("clients.openwrt.desc.title")}
      </MKTypography>
      <MKTypography variant="body2" color="text" mb={2}>
        {t("clients.openwrt.desc.intro")}
      </MKTypography>
      <Grid container spacing={2}>
        {openWrtSections.map((section) => (
          <Grid key={section.packageType} item xs={12} md={6}>
            <Stack
              spacing={1.5}
              sx={{
                height: "100%",
                border: "1px solid",
                borderColor: "grey.300",
                borderRadius: 1,
                p: 2,
              }}
            >
              <MKTypography variant="h6" fontWeight="bold">
                {t(section.titleKey)}
              </MKTypography>
              <MKTypography variant="body2" color="text">
                {t(section.subtitleKey)}
              </MKTypography>
              {section.groups.map((group) => (
                <Stack key={group.titleKey} spacing={1}>
                  <MKTypography variant="button" fontWeight="bold" color="text">
                    {t(group.titleKey)}
                  </MKTypography>
                  <Stack direction="row" flexWrap="wrap" gap={1}>
                    {group.targets.map(([target, label]) => {
                      const download = downloadsByTypeAndArch.get(
                        `${section.packageType}:${target}`
                      );
                      if (!download) return null;
                      return (
                        <SignedDownloadButton
                          key={download.slug || `${section.packageType}-${target}`}
                          variant="outlined"
                          color="info"
                          linkUrl={download.signed_link_url}
                          label={label}
                        />
                      );
                    })}
                  </Stack>
                </Stack>
              ))}
            </Stack>
          </Grid>
        ))}
      </Grid>
    </Card>
  );
}

export default OpenWrtDesc;
